import { CHANNEL_NAMESPACE, ChannelType } from './types';

export interface IBuildChannelNameParams {
  /** Channel as named by the platform, e.g. `bonuses_changes` or `public:jackpots_changes` */
  channel: string | null;
  /** `client_name` from the subscription settings */
  clientName?: string;
  /** Centrifugo user identifier, absent for guests */
  user?: string;
  channelType: ChannelType;
  /** `ws` by default, `wsh` for channels with history */
  namespace?: string;
}

export const buildChannelName = ({
  channel,
  clientName,
  user,
  channelType,
  namespace = CHANNEL_NAMESPACE,
}: IBuildChannelNameParams): string | null => {
  if (!(channel && clientName)) return null;

  const base = `${namespace}:${clientName}:${channel}`;

  switch (channelType) {
    case ChannelType.Public:
      return base;
    case ChannelType.Private:
      return user ? `${base}#${user}` : null;
    default:
      return null;
  }
};
